// extracted by mini-css-extract-plugin
module.exports = {"dotsMenuWrap":"style-module--dotsMenuWrap--2ZE-K","dotsMenu":"style-module--dotsMenu--3xtQm","dot":"style-module--dot--L0XAR","dotsPopup":"style-module--dotsPopup--ln6BS"};